import { render, staticRenderFns } from "./ancientBooks.vue?vue&type=template&id=554926e6&scoped=true&"
import script from "./ancientBooks.vue?vue&type=script&lang=js&"
export * from "./ancientBooks.vue?vue&type=script&lang=js&"
import style0 from "./ancientBooks.vue?vue&type=style&index=0&id=554926e6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554926e6",
  null
  
)

export default component.exports